import { createRoute, useParams } from "@tanstack/solid-router";
import { Show } from "solid-js";
import { slidesRoute } from "./slides";
import { SlideDocument } from "@/features/documents/components/slide-document";

function SlideDocumentPage() {
  const params = useParams({ from: "/_app/slides/$pageId" });
  // keyed: remounts editor when document changes (clean state)
  return (
    <Show when={params().pageId} keyed>
      {(pageId) => <SlideDocument pageId={pageId} />}
    </Show>
  );
}

export const slidesDocRoute = createRoute({
  getParentRoute: () => slidesRoute,
  path: "/$pageId",
  component: SlideDocumentPage,
});
